import { formatGold } from '../format';
import { expeditionLossReason } from '../combatApi';
import type { ScreenMount } from '../types';
import { buildDamageRecap } from './damageRecap';
import { icon } from '../icons';
import { mountTips } from '../tips';

/**
 * Écran de fin d'Expédition. **Perdue** (Serpent, A28 — `combat.lost`) :
 * titre dédié, raison quand elle est connue, or gagné forcé à 0 (l'or en
 * attente a été perdu par le cœur, mais on ne suppose pas la valeur exacte de
 * `combat.gold` à cet instant). Le bouton continue vers l'Accalmie comme
 * d'habitude : le jour est consommé, la run se poursuit.
 */
export const mountExpeditionEnd: ScreenMount = (container, ctx) => {
  const { game } = ctx;
  const c = game.state.combat as unknown as { gold: number; kills: number; bestThrow: number; lost?: boolean };
  const lost = c.lost === true;
  const title = lost ? 'Expédition perdue' : 'Expédition terminée';
  const reason = lost ? (expeditionLossReason() ?? "Le combat s'est arrêté avant la victoire.") : null;
  const goldEarned = lost ? 0 : c.gold;
  const el = document.createElement('div');
  el.className = `screen screen--end screen--end-recap${lost ? ' screen--end-lost' : ''}`;
  // v0.16.0 (refonte F1, lot 3) : bandeau d'or (sang si l'Expédition est
  // perdue), tuiles de statistiques aux chiffres en Cinzel, bouton de pierre.
  el.innerHTML = `
    <div class="end-center">
      <header class="f-banner ${lost ? 'f-banner--loss' : 'f-banner--win'}">
        <h1 class="end-title">${title}</h1>
      </header>
      ${reason ? `<p class="end-note" data-role="expedition-lost-reason">${reason}</p>` : ''}
      <dl class="end-stats end-stats--3">
        <div class="f-stat f-stat--gold end-stat"><dt>Or gagné</dt><dd class="num">${formatGold(goldEarned)}</dd></div>
        <div class="f-stat end-stat"><dt>Ennemis tués</dt><dd class="num">${c.kills}</dd></div>
        <div class="f-stat end-stat"><dt>Meilleur lancer</dt><dd class="num">${formatGold(c.bestThrow)}</dd></div>
      </dl>
    </div>
    <button type="button" class="f-btn f-btn--primary f-btn--block end-action" data-action="accalmie"><span>Accalmie</span>${icon('arrow')}</button>
  `;
  // Récapitulatif des dégâts (COMMENTS §2) : déplié d'entrée en fin
  // d'Expédition, inséré avant le bouton collant pour rester scrollable.
  el.insertBefore(buildDamageRecap(game, { open: true }), el.lastElementChild);
  container.appendChild(el);

  const btn = el.querySelector<HTMLButtonElement>('[data-action="accalmie"]');
  const onClick = (): void => game.goToAccalmie();
  btn?.addEventListener('click', onClick);
  // Info-bulle de première partie : le récapitulatif (phase 4, `ui/tips.ts`).
  const offTips = mountTips(ctx, 'expeditionEnd', el);

  return () => {
    offTips();
    btn?.removeEventListener('click', onClick);
  };
};
